import React, { Component } from "react";
import { connect } from "react-redux";

import { createPushNotification } from "actions/pushNotification";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/PushNotifications/Form";

class PushNotificationCreate extends Component {
  handleFormSubmit = (data) => {
    const { activeCompany } = this.props;

    data = Object.assign({}, data, { company_url: activeCompany.url });
    this.createPushNotification(data);
  };

  createPushNotification(data) {
    const {
      toggleNotification,
      activeCompany,
      toggleFullPageSpinner,
      createPushNotification,
      history,
    } = this.props;

    toggleFullPageSpinner(true);

    createPushNotification(data)
      .then(() => {
        toggleNotification(true, {
          message: "Created PushNotification Success",
          infoClassName: "is-success",
        });
        history.push(`/${activeCompany.url}/pushNotifications`);
      })
      .catch((e) => {
        toggleNotification(true, {
          message: e.message,
          infoClassName: "is-danger",
        });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  render() {
    const { activeCompany } = this.props;

    return (
      <Form
        handleFormSubmit={this.handleFormSubmit}
        activeCompany={activeCompany}
      />
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {
  createPushNotification,
  toggleFullPageSpinner,
  toggleNotification,
})(PushNotificationCreate);
